<template>
	<div grey-back full-height>

    <v-toolbar flat fixed>
        <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
        <v-toolbar-title class="white--text">About</v-toolbar-title>
    </v-toolbar>

       <div class="hasToolbar">

            <v-list nopadding>

                <v-list-tile v-ripple @click="fn_openTerms">

                    <v-list-tile-content>
                        <v-list-tile-title>Terms of Service</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-icon>keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile to="/settings/about/libraries" v-ripple>

                    <v-list-tile-content>
                        <v-list-tile-title>Open Source Libraries</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-icon>keyboard_arrow_right</v-icon>
                    </v-list-tile-action>
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile v-ripple>

                    <v-list-tile-content>
                        <v-list-tile-title>App Version</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <span>{{appVersion}}.0</span>
                    </v-list-tile-action>
                </v-list-tile>

            </v-list>
        </div>

</div>
</template>

<script>

  export default{
    data(){
      return{
        appVersion:null
      }
    },

    methods:{

      fn_openTerms: function(){
        AndroidRoutingTest.openBrowser("https://bizopsapp.com/terms");
      },

      fn_goBack: function(){
        this.$router.go(-1);
      },

      fn_showWebView: function () {
        this.showWebView("about", {}, 
          {
            onSuccess: function(response){
              console.log(response);
            }, 
            onError: function(error){
              console.log(error);
            }, 
          }
        );
      },

      // fn_getAndroidAppVer: function(){
      //   let self = this;
      //     this.getData('AndroidAppVersion', null, 
      //         {
      //             onSuccess: function(response){
      //               console.log(response);
      //               self.appVersion = response;
      //             }, 
      //             onError: function(error){
      //               console.log(error);
      //             }
      //         }
      //     );
      // }

      fn_getAndroidAppVer: function(){
        let self = this;
          this.getData('AndroidAppVersionName', null, 
              {
                  onSuccess: function(response){
                    console.log(response);
                    self.appVersion = response;
                  }, 
                  onError: function(error){
                    console.log(error);
                  }
              }
          );
      }

    },
    mounted: function () { 
      console.log(process.env.webVersion);
      window.js_globals.fn_onBackPress = this.fn_goBack;
      this.fn_getAndroidAppVer();
      this.fn_showWebView();
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/settings/about/about.vue